module.exports = __webpack_public_path__ + "static/mobilenotifications-length-dont-c0d9526afb106d8940a2f8ff1fbfe470.png";